import { updatingRulesUtil } from '../../../updatingRulesUtil';
import { ConstraintsAndPreferences, CalculateUtil, DialogComponentUtil } from '..';

/**
 * 
 * @param {one shedule constraint object} scheduleConstraintsObj 
 * @param {one cell data object from dataTableMap} dataObj 
 */
export const deletingRules = async (scheduleConstraintsObj, dataObj) => {
  let constraintsArray = updatingRulesUtil.constraintsArray
  let dataTableObjConstraints = updatingRulesUtil.dataTableObjConstraints

  for (let a = 0; a < dataTableObjConstraints.length; a++) {
    let dataTableConstraintName = dataTableObjConstraints[a]
    let constraintsName = constraintsArray[a]
    if (dataObj[dataTableConstraintName] !== undefined) {

      let dataTableObj = dataObj[dataTableConstraintName]
      let rulesArray = scheduleConstraintsObj[constraintsName]

      let constraintObjIndex = DialogComponentUtil.findConstraintObjIndexToReplace(rulesArray, dataTableObj)
      if (constraintObjIndex !== undefined) {
        rulesArray.splice(constraintObjIndex, 1)
      }
      delete dataObj[dataTableConstraintName]
    }
  }
}

export const updatingTheRulesCount = async (scheduleConstraintsObj) => {
  scheduleConstraintsObj = await CalculateUtil.calculateConstraintsAndPreference(scheduleConstraintsObj, ConstraintsAndPreferences.Constants.JOINT_CLASSES)
  scheduleConstraintsObj = await CalculateUtil.calculateConstraintsAndPreference(scheduleConstraintsObj, ConstraintsAndPreferences.Constants.MULTI_PERIODS)
  scheduleConstraintsObj = await CalculateUtil.calculateConstraintsAndPreference(scheduleConstraintsObj, ConstraintsAndPreferences.Constants.TEACHERS_AND_TAS_FOR_SUBJECTS)
  scheduleConstraintsObj = await CalculateUtil.calculateConstraintsAndPreference(scheduleConstraintsObj, ConstraintsAndPreferences.Constants.TEACHERS_AND_TAS_FOR_ELECTIVES)
  scheduleConstraintsObj = await CalculateUtil.calculateConstraintsAndPreference(scheduleConstraintsObj, ConstraintsAndPreferences.Constants.FIXED_TEACHERS_AND_TAS_FOR_SUBJECTS)
  scheduleConstraintsObj = await CalculateUtil.calculateConstraintsAndPreference(scheduleConstraintsObj, ConstraintsAndPreferences.Constants.FIXED_TEACHERS_AND_TAS_FOR_ELECTIVES)
  scheduleConstraintsObj = await CalculateUtil.calculateConstraintsAndPreference(scheduleConstraintsObj, ConstraintsAndPreferences.Constants.PREFERRED_PERIODS)
  scheduleConstraintsObj = await CalculateUtil.calculateConstraintsAndPreference(scheduleConstraintsObj, ConstraintsAndPreferences.Constants.REQUIRED_SHARED_ROOM_FOR_SUBJECTS)
  scheduleConstraintsObj = await CalculateUtil.calculateConstraintsAndPreference(scheduleConstraintsObj, ConstraintsAndPreferences.Constants.REQUIRED_SHARED_ROOM_FOR_ELECTIVES)
}

export const deleteingParticulrGradeObject = (scheduleConstraintsObj, dataObj) => {
  let constraintsArray = updatingRulesUtil.constraintsArray;
  let gradeName = dataObj.grade
  let id = dataObj.subject !== undefined ? dataObj.subject._id : dataObj.elective._id

  for (let i = 0; i < constraintsArray.length; i++) {

    let rulesArray = scheduleConstraintsObj[constraintsArray[i]]
    if (rulesArray.length > 0) {
      //RULES ARRAY
      for (let j = 0; j < rulesArray.length; j++) {
        let ruleObj = rulesArray[j]
        // check if the rule object is for the same SUBJECT that of the selected cell subject
        if ((ruleObj.subjectId === id) || (ruleObj.electiveId === id)) {
          //check if the GRADES of both the selected cell and the rule object matches 
          if (ruleObj.gradeDetails.grades[0].grade === gradeName
            && ruleObj.gradeDetails.grades[0].groups.length === 0) {
            rulesArray.splice(j, 1);
            break
          }
        }
      }
    }
  }
}